import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { convertDate } from "../../../utils";
import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import { BlockDes, BlockTitle } from "../../../components/Block/Block";
import WalletSection from "../../../components/WalletSection/WalletSection";
import FAQSection from "./../../../components/FAQSection/FAQSection";
import "chart.js/auto";
import Icon from "../../../components/Icon/Icon";
import { useNavigate } from "react-router-dom";
import { ConvertCurrency } from "../../../helpers/Currency/Currency";
import { transactionUserContext } from "../../../context/UserContext/TransactionUserContext/TransactionUserContext";
import { categoryItems, categoryItemsFarsi } from "../../../utils/enum";
import UserNotification from '../../../helpers/Header/UserNotification/UserNotification'
import Banners from "../../../components/Banners/Banners";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/autoplay";

const dashboardItems = [
  { key: 'household', title: 'خرید روزانه', icon: '/assets/images/icons/dash_household.svg' },
  { key: 'sustenance', title: 'خرید ارزاق', icon: '/assets/images/icons/dash_sustenance.svg' },
  { key: 'travel', title: 'سفر و گردشگری', icon: '/assets/images/icons/dash_travel.svg' },
  { key: 'travel', title: 'سفر و گردشگری', icon: '/assets/images/icons/dash_travel.svg' },
  { key: 'entertainment', title: 'ورزش و سرگرمی', icon: '/assets/images/icons/dash_entertainment.svg' },
  { key: 'education', title: 'آموزشی', icon: '/assets/images/icons/dash_education.svg' },
  { key: 'gift', title: 'مناسبتی', icon: '/assets/images/icons/dash_holidays.svg' },
]

function DashboardCustomer() {
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();

  const {
    transactions,
    handleGetTransactions,
  } = useContext(transactionUserContext);

  useEffect(() => {
    handleGetTransactions();
  }, []);

  // Slider
  const theme = [
    "bg-gradient-red",
    "bg-gradient",
    "bg-gradient-black",
  ]
  const walletSliderItems = () => {
    const newItems = categoryItems.map((key, index) => ({ id: index + 1, type: key, value: categoryItemsFarsi[index], theme: theme[index % theme.length] }));
    newItems.push({ id: newItems.length + 1, type: 'none', value: '', theme: theme[2] })
    return newItems;
  }

  // utils
  const findPrice = (item) => {
    if (!item) return 0
    const key = Object.keys(item.amount).find(key => item.amount[key] > 0)
    const price = item.amount[key]
    return price
  }

  return (
    <>
      <SiteTitle title="داشبورد" />

      {/* -- --- ---- >> >>> Header <<< << ---- --- -- */}
      <div className="d-flex justify-between align-center mb-3">
        <div className="d-flex align-center">
          <div className="mx-2 rounded-pill border justify-center align-center" style={{ width: '56px', height: '56px' }}>
            {user.avatar ? <img src={user.avatar} alt="user" /> : <Icon name='user' className='fs-25px' />}
          </div>
          <div>
            <BlockTitle tag="h6" className='mb-n1'>
              {`${user.firstName} ${user.lastName}`}
            </BlockTitle>
            <BlockDes className="text-soft mt-1">
              {user.phoneNumber}
            </BlockDes>
          </div>
        </div>
        <div
          className="rounded-2xl border justify-center align-center cursor-pointer"
          style={{ width: '48px', height: '48px' }}
        >
          <li className="notification-dropdown">
            <UserNotification />
          </li>
        </div>
      </div>

      {/* -- --- ---- >> >>> Slider <<< << ---- --- -- */}
      <div className="d-md-none">
        <Swiper
          navigation={true}
          loop
          autoplay
          speed={5000}
          spaceBetween={30}
          modules={[Autoplay]}
        >
          {walletSliderItems().map(item => (
            <SwiperSlide>
              <div key={item.type}>
                <WalletSection wallet={item} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="d-none d-md-block d-lg-none">
        <Swiper
          navigation={true}
          loop
          autoplay
          slidesPerView={2}
          speed={5000}
          spaceBetween={15}
          modules={[Autoplay]}
        >
          {walletSliderItems().map(item => (
            <SwiperSlide>
              <div key={item.type}>
                <WalletSection wallet={item} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="d-none d-lg-block">
        <Swiper
          navigation={true}
          loop
          autoplay
          slidesPerView={3}
          speed={5000}
          spaceBetween={15}
          modules={[Autoplay]}
        >
          {walletSliderItems().map(item => (
            <SwiperSlide>
              <div key={item.type}>
                <WalletSection wallet={item} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="row mb-4">
        {!isEmpty(dashboardItems) && dashboardItems.map((item, index) => {
          if (index === 3) return <div className="w-100 d-sm-none"></div>
          return (
            <div
              key={item.key}
              className="col flex flex-column align-center my-2 justify-center cursor-pointer"
              onClick={() => navigate(`services/${item.key}`)}
            >
              <img src={item.icon} alt={item.key} className="mb-1" />
              <p>{item.title}</p>
            </div>
          )
        })}
      </div>


      {/* Banners */}
      <Banners />

      <div className="my-5 px-1">
        <div className="align-center">
          <div className="bg-orange-dim p-1 rounded-pill d-flex p-2" style={{ width: 56, height: 56 }}>
            <img src="/assets/images/logos/household.png" alt="hotels" />
          </div>
          <h4 className="ml-3">آخرین تراکنشات</h4>
        </div>
        <div className="w-100 my-4">

          {!isEmpty(transactions) ? transactions.map((item, index) => {
            if (index > transactions.length - 6) return (
              <div>
                <div className='justify-between my-2'>
                  <div className="align-center overflow-hidden">
                    <img
                      src={`/assets/images/icons/card-${item.type === 'deposit' ? 'receive' : 'send'}.svg`}
                      width={27}
                      height={27}
                      alt=" "
                    />
                    <div className="ml-3 overflow-hidden" >
                      <p className="fs-17px text-dark m-0 text-truncate">{item.type === 'transfer' ? 'انتقال به ' : item.type === 'deposit' ? 'واریز از' : 'برداشت'} {' '} {`${item.user.firstName}  ${item.user.lastName}`}</p>
                      <div className="d-flex text-soft pr-3 pl-1">
                        <p className="m-0 text-nowrap">کد رهگیری </p>
                        <p className="ml-3 text-truncate">{item.trackingCode}</p>
                      </div>
                    </div>
                  </div>
                  <div className="flex-column align-end justify-center">
                    <p className="m-0 text-dark fs-13px">{convertDate(item.createdAt)}</p>
                    <p className="text-nowrap">
                      <ConvertCurrency price={findPrice(item)} /> {' '}
                      <span className="text-soft fs-12px">تومان</span>
                    </p>
                  </div>
                </div>
                {index < 3 &&
                  <div className="border-top" />
                }
              </div>
            )
          })
            : <div className="text-center">داده‌ای برای نمایش یافت نشد</div>}
        </div>
        <button
          className="btn btn-outline-light w-100 rounded-xl align-center justify-center py-3 fs-16px"
          onClick={() => navigate('/customer/transactions')}
        >
          مشاهده بیشتر
        </button>
      </div>

      <FAQSection />
    </>
  );
};

export default DashboardCustomer;
